<template>
  <div class="c-filter">
    <div class="c-btn"></div>
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="月份">
          <ElDatePicker v-model="month" @change="sendEvent" value-format="yyyy-MM" type="month" placeholder="不限" style="width: 180px">
          </ElDatePicker>
        </ElFormItem>
        <ElFormItem label="游戏组">
          <ThrottleSelector
            v-model="gameId"
            :list="games"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>
        <ElFormItem label="媒体">
          <ThrottleSelector
            v-model="mediaId"
            :list="medias"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem class="bg-transparent" label-width="0">
          <div class="operate-btns">
            <ElButton type="primary" @click="$emit('on-set')">新增绩效KPI</ElButton>
            <ElButton @click="$emit('on-down')">模板下载</ElButton>
            <Upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
              <ElButton style="margin-left: 10px">导入绩效考核</ElButton>
            </Upload>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'
export default {
  name: 'recordKpi',
  components: { ThrottleSelector },
  props: {
    medias: {
      type: Array,
      default() {
        return []
      }
    },
    games: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    sendEvent() {
      const params = {
        mediaId: this.mediaId === -1 ? undefined : this.mediaId,
        gameId: this.gameId === '' ? undefined : this.gameId,
        reportMonth: this.month === '' ? undefined : this.month
      }
      this.$emit('on-change', params)
    },

    preUpload(file) {
      this.emitImport(file)
      return false
    },
    emitImport(file) {
      this.$emit('on-import', file)
    }
  },
  data() {
    return {
      month: '', // 月份
      mediaId: '',
      gameId: '',
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.operate-btns {
  display: flex;
  ::v-deep .ivu-upload-list {
    margin-top: 0;
  }
}
</style>
